import { api, generateCRUDInterface } from "aldoo-ra/API"

const crudAPI = api("crud")
const crud = generateCRUDInterface(crudAPI, "Organization")

// the CMS select dialog filters `deleted: false` and searches several field
// names; an organization has neither, it is found by its name
const searchMatch = (match = {}) => {
  const { deleted, $or, ...rest } = match
  const query = $or?.map((entry) => Object.values(entry)[0]).find((value) => value?.$regex)
  return query ? { ...rest, name: query } : rest
}

crud.Get = async (get = {}) =>
  crudAPI({ get: { ...get, model: "Organization", match: searchMatch(get.match), sort: get.sort || { name: 1 } } })

export default crud
